export default __webpack_public_path__ + "static/media/wind-tower.32d93657.gif";